module.exports = __webpack_public_path__ + "static/media/24-iveco.2514e8c7.jpg";